import React, { useState } from 'react';

import Modal, { ModalBody, ModalFooter } from '../ui/Modal';
import Button from '../ui/Button';
import { TextField } from '../ui/FormField';

// Redesign of newadmin/elements/AddAgentModal.js. NOTE: the original submit
// is a stub — it makes no server call, just resets and closes. Replicated
// identically (presentation-only rewrite).
const AddAgentModal = ({ open, onClose }) => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');

    const close = () => {
        setName('');
        setEmail('');
        onClose();
    };

    const formSubmit = (e) => {
        e.preventDefault();
        close();
    };

    return (
        <Modal open={open} onClose={close} title="Add Agent" size="lg">
            <form onSubmit={formSubmit} className="flex flex-col flex-1 min-h-0 overflow-hidden">
                <ModalBody className="flex-1">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <TextField
                            label="Agent Name"
                            required
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Agent Name"
                        />
                        <TextField
                            label="Email"
                            required
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Email"
                        />
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button variant="secondary" onClick={close}>
                        Close
                    </Button>
                    <Button type="submit">Add Agent</Button>
                </ModalFooter>
            </form>
        </Modal>
    );
};

export default AddAgentModal;
